













import {
  Component,
  Prop,
  Vue
} from "../vuepack";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import { Watch } from "@/shared/vuepack";
import { Home } from "@/shared/route-names";
import MfaWidget from "@/shared/components/MfaWidget.vue";
import { RawLocation } from "vue-router";
import { useMfaStore } from "@/shared/store/mfa";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    MfaWidget,
    LoginWrapper,
  }
})
export default class CognitoMfaVerify extends Vue {
  mfaStore = useMfaStore();
  userStore = useUserStore();

  @Prop()
  Username: string;

  @Prop()
  Password: string;

  @Prop()
  MfaType: string;

  @Prop()
  SetupBiometricAuth: boolean;

  @Prop()
  FailureRouteFunc: () => RawLocation;

  @Prop()
  LostDeviceRouteFunc: () => RawLocation;

  @Prop()
  routeToBiometricAuthSetup: (user: string, password: string) => RawLocation;

  mounted () {
    if (!this.Username || !this.Password) {
      this.$router.push(this.FailureRouteFunc());
    }
  }

  @Watch("userStore.loggedIn")
  onLoggedIn (isLoggedIn) {
    if (!isLoggedIn) {
      return;
    }

    this.mfaStore.sendMfaStatus({ status: this.MfaType });
    if (this.SetupBiometricAuth) {
      this.$router.push(this.routeToBiometricAuthSetup(this.Username, this.Password));
      return;
    }

    if (this.$route.query && this.$route.query.returnUrl) {
      this.$router.push(this.$route.query.returnUrl as string);
      return;
    }

    this.$router.push({ name: Home });
  }

  lostDevice () {
    this.$router.push(this.LostDeviceRouteFunc());
  }
}
